import React from 'react';
import { Button as MuiButton, useTheme } from '@mui/material';
import { Icon, JamIcon } from 'components/ui';
import { useTranslation } from 'react-i18next';

function GetAddSettings() {
  const { t } = useTranslation();
  const theme = useTheme()
  const actions = (
    <MuiButton color="primary" variant="contained" type="submit">
      <Icon icon="calendar-plus" size="1x" mr={10} /> {t('Create appointment')}
    </MuiButton>
  );

  const title = (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <JamIcon size={24} icon="calendar" color={theme.palette.colors.blue100} />
      {t('New appointment')}
    </div>
  );

  return {
    actions,
    title,
  };
}

export default GetAddSettings;
